e4.product = {
    init: function () {
        var jProduct = jQuery( '.js-e-product' );
        if ( jProduct.data( 'variant' ) === true ) {
            e4.product.variants.init();
        }
        if ( jQuery( '.js-e-product-form, .js-e-productlist' ).length > 0 ) {
            e4.product.bindEvents();
        }
        if(jQuery('.js-outlet-form').length > 0){
            e4.product.outlet.init();
        }
    },
    bindEvents: function () {
        jQuery( document ).on( 'submit', '.js-e-product-form', function ( event ) {
            var jForm = jQuery( event.target );
            if ( jForm.is( '.js-e-product-form-removefromcart' ) === true ) {
                e4.product.removeFromCart( event );
            }
            else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                jForm.find('button[type="submit"]').prop('disabled', true);
                e4.product.addToCart( event );
            }
        } );
    },
    getGeneratedGUID: function() {
        var d = new Date().getTime();//Timestamp
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16;//random number between 0 and 16
            if(d > 0){//Use timestamp until depleted
                r = (d + r)%16 | 0;
                d = Math.floor(d/16);
            } else {//Use microseconds since page-load if supported
                r = (d2 + r)%16 | 0;
                d2 = Math.floor(d2/16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    },
    addToCart: function ( event ) {
        event.preventDefault();
        var jForm       = jQuery( event.target ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.addProduct( objFormData );
        }
        else {
            e4.cart.addProduct( objFormData );
        }
        //jForm.find('button[type="submit"]').prop('disabled', false);
        var strOrderlineGroupID = e4.product.getGeneratedGUID();
        jForm.find('input[name^="EcomOrderLineFieldInput_OrderlineGroupID"]').val(strOrderlineGroupID);
        jForm.find('button[type="submit"]').prop('disabled', false);
        
        
    },
    removeFromCart: function ( event ) {
        event.preventDefault();
        var jForm       = jQuery( event.target ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.removeProduct( objFormData );
        }
        else {
            e4.cart.removeProduct( objFormData );
        }
    },
    outlet:{
        outletForm: jQuery('.js-outlet-form'),
        basicPricePerM2: null,
        init: function () {
            e4.product.outlet.basicPricePerM2 = e4.product.outlet.outletForm.find('.js-total-outlet-price').data('basicprice');
            e4.product.outlet.bindEvents();
        },
        bindEvents: function(){
            e4.product.outlet.outletForm.on('change', '.js-junckers-goal-sqm', function(event){
                e4.product.outlet.setSqmValue(jQuery(event.target));
            });

            e4.product.outlet.outletForm.on('change', '.js-outlet-checkbox', function(event){
                e4.product.outlet.calculate();
            });

            e4.product.outlet.outletForm.find( '.js-junckers-goal-sqm').trigger('change');
        },
        m2: null,
        priceFormatted: function(num, includeCurrency) {
            var charDecimalSeparator = e4.product.outlet.outletForm.data('currencydecimalseparator'),
                charGroupSeparator = e4.product.outlet.outletForm.data('currencygroupseparator'),
                strCurrencyCode = e4.product.outlet.outletForm.data('currencycode'),
                strCurrencysymbol = e4.product.outlet.outletForm.data('currencysymbol'),
                intCurrencysymbolplace = e4.product.outlet.outletForm.data('currencysymbolplace'),
                returnValue = num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

            returnValue = returnValue.split('.').join('_');
            returnValue = returnValue.split(',').join(charGroupSeparator);
            returnValue = returnValue.split('_').join(charDecimalSeparator);
            if(includeCurrency){
                if(intCurrencysymbolplace === 0){
                    returnValue = strCurrencysymbol + ' ' + returnValue;
                } else {
                    returnValue = returnValue + ' ' + strCurrencyCode;
                }
            }
            return returnValue;
        },
        setSqmValue: function(jInputElement){
            var intM2waste = jInputElement.data('m2waste'),
                accm2number = jInputElement.data('accm2number'),
                collinumber = jInputElement.data('collinumber') <= 0 ? 1 : jInputElement.data('collinumber'),
                intSqmWithWaste = jInputElement.val() / collinumber,// *accm2number,// (1+(intM2waste/100)),
                intRoundedSqmWithWaste = Math.ceil(intSqmWithWaste), //unit quantity
                calculatedSqm = (collinumber * intRoundedSqmWithWaste),//.toFixed(2), //m2 quantity
                intRoundedCalculatedSqm = calculatedSqm.toFixed(2),// Math.ceil(calculatedSqm),
                boolQuantityChanged = e4.product.outlet.outletForm.find('.js-junckers-quantity').val() !== ''+intRoundedCalculatedSqm;



            console.log('jInputElement', jInputElement, 'val', jInputElement.val());
            console.log('e4.product.outlet.basicPricePerM2', e4.product.outlet.basicPricePerM2, 'intM2waste', intM2waste,'accm2number', accm2number,'collinumber', collinumber,'intSqmWithWaste', intSqmWithWaste,'intRoundedSqmWithWaste', intRoundedSqmWithWaste,'calculatedSqm', calculatedSqm,'intRoundedCalculatedSqm', intRoundedCalculatedSqm,'boolQuantityChanged', boolQuantityChanged);

            //var dblCalcedSqmFromColli = intRoundedSqmWithWaste * collinumber;
            //13 * 1.89 = 24.57sqm

            e4.product.outlet.outletForm.find('.js-main-product-quantity').text(intRoundedSqmWithWaste);
            e4.product.outlet.outletForm.find('.js-junckers-quantity').val(intRoundedCalculatedSqm);
            e4.product.outlet.outletForm.find('.js-outlet-mainproduct-orderline-floorsqm').val(intRoundedSqmWithWaste);
            e4.product.outlet.calculate();

            if(boolQuantityChanged && jQuery('.js-junckers-variant-picker').length > 0){
                junckers.variants.setAvailableVariantOptions();
            }
        },
        calculate: function(){
            e4.product.outlet.m2 = e4.product.outlet.outletForm.find('.js-junckers-quantity').val();
            if(e4.product.outlet.m2 < 0){
                e4.product.outlet.m2 = 0;
                e4.product.outlet.outletForm.find('.js-junckers-quantity').val(e4.product.outlet.m2);
            }
            var numBasicPrice = e4.product.outlet.basicPricePerM2 * e4.product.outlet.m2;
            e4.product.outlet.outletForm.find('.js-total-outlet-price').data('basicprice', numBasicPrice);

            var numTotalCollectionPrice = e4.product.outlet.outletForm.find('.js-total-outlet-price').data('basicprice');
            jQuery.each(e4.product.outlet.outletForm.find('.js-outlet-choose-accessory'), function ( intIndex, domElement ) {
               var jElementProductGroupContainer = jQuery(domElement),
                   numTotalProductGroupPrice = 0;

               jQuery.each(jElementProductGroupContainer.find('.js-calc-part-product'), function ( intIndex, domElement ) {
                   var jElement = jQuery(domElement);
                   var units = e4.product.outlet.m2 * jElement.data('perm2');
                   var quantity = units / jElement.data('collinumber');
                   var quantityWithWaste = quantity * (1+(jElement.data('m2waste')/100));
                   var roundedQuantity = Math.ceil(quantityWithWaste);
                   var price = roundedQuantity * jElement.data('price');
                   if(jElementProductGroupContainer.find('.js-outlet-checkbox').prop('checked')){
                       jElement.find('.js-junckers-accessories-quantity').val(roundedQuantity);
                       numTotalCollectionPrice += price;
                   } else {
                       jElement.find('.js-junckers-accessories-quantity').val(0);
                   }
                   numTotalProductGroupPrice += price;
               });
                jElementProductGroupContainer.find('.js-outlet-choose-accessory-calcprice').data('totalprice', numTotalProductGroupPrice).html(e4.product.outlet.priceFormatted(numTotalProductGroupPrice, true));
            });
            e4.product.outlet.outletForm.find('.js-total-outlet-price').find('.e-price-price').html(e4.product.outlet.priceFormatted(numTotalCollectionPrice, false));
        }
    },
    variants: {
        init: function () {
            var productId = jQuery( '.js-e-product' ).data( 'productid' );
            if ( junckers.data.product[ productId ] !== undefined ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'counter' );
                    e4.product.variants.handlebars.helpers();
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-variant-package-size' );
                    e4.product.variants.bindEvents();
                } );
            }
        },
        handlebars: {
            helpers: function () {
                Handlebars.registerHelper( 'striptags', function ( txt ) {
                    return txt;
                } );
                Handlebars.registerHelper('packageSizeNumber', function(number, index) {
                    var n = number.split(" ");
                    return n[index] !== undefined ? n[index] : ""; 
                });
            }
        },
        bindEvents: function () {
            jQuery( '.js-e-product' ).find( '.js-junckers-variant-form' )
            .on( 'change', e4.product.variants.setDetails );
            jQuery(document).ready(function() {
                jQuery( "input:radio:first" ).trigger( "click" );
                jQuery( '.js-chosen-variant-image').attr("src", jQuery( "input:radio:first" ).data('image'))
                
            });
        },
        setDetails: function ( event ) {
            var jProduct     = jQuery( '.js-e-product' ),
                productId = jProduct.data( 'productid' );

            jQuery( '.js-chosen-variant-image').attr("src", jQuery( event.target ).data('image'))
            
            if ( junckers.data.product[ productId ].variantCombos[ event.target.value ] !== undefined ) {
                var jsonProduct = junckers.data.product[ productId ].variantCombos[ event.target.value ];
                jProduct.find( '.js-junckers-variant-package-size' ).html( e4.handlebars.tmpl.variantPackageSize( jsonProduct ) );
            } else {
                var jsonProduct = junckers.data.product[ productId ].variantCombos[ event.target.value ];
                jProduct.find( '.js-junckers-variant-package-size' ).html( "<div class='btn'>&nbsp;</div>" );
            }
        }
    }
};
